<h1 mat-dialog-title *ngIf="modalEsp">{{'MODALES.TITULOS.'+titulo | translate}}</h1>
<h1 mat-dialog-title *ngIf="!modalEsp">{{'MODALES.TITULO' | translate}}</h1>

<mat-dialog-content *ngIf="modalEsp" [innerHTML]="'MODALES.MENSAJES.'+data.diccionario+data.mensaje | translate"></mat-dialog-content>
<mat-dialog-content *ngIf="!modalEsp">{{'MODALES.MENSAJES.'+data.message | translate}}</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!botonesConfirmar">
  <button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="botonesConfirmar">
  <button mat-button mat-dialog-close [mat-dialog-close]="true">{{'MODALES.ACCIONES.aceptar' | translate}}</button>
  <button mat-button mat-dialog-close [mat-dialog-close]="false">{{'MODALES.ACCIONES.cancelar' | translate}}</button>
</mat-dialog-actions>
